import { Box } from '@mui/material';
import { InputProps, required, TextInput, WrapperField } from 'react-admin';
import { IntegrationRecord } from '../../../common/types';
import IntegrationInfo from './IntegrationInfo';

const OhipInputs = ({
  integration,
}: Omit<InputProps, 'source'> & { integration: IntegrationRecord }) => (
  <WrapperField>
    <IntegrationInfo integration={integration} />
    <Box width="70%" maxWidth="70%">
      <TextInput
        source="currentConfig.service.apiBaseUrl"
        label="resources.integrations.fields.ohip.apiBaseUrl.label"
        helperText="resources.integrations.fields.ohip.apiBaseUrl.helperText"
        type="url"
        validate={required(
          'resources.integrations.fields.ohip.apiBaseUrl.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.clientId"
        label="resources.integrations.fields.ohip.clientId.label"
        helperText="resources.integrations.fields.ohip.clientId.helperText"
        validate={required(
          'resources.integrations.fields.ohip.clientId.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.clientSecret"
        label="resources.integrations.fields.ohip.clientSecret.label"
        helperText="resources.integrations.fields.ohip.clientSecret.helperText"
        validate={required(
          'resources.integrations.fields.ohip.clientSecret.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.username"
        label="resources.integrations.fields.ohip.username.label"
        helperText="resources.integrations.fields.ohip.username.helperText"
        validate={required(
          'resources.integrations.fields.ohip.username.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.password"
        label="resources.integrations.fields.ohip.password.label"
        helperText="resources.integrations.fields.ohip.password.helperText"
        validate={required(
          'resources.integrations.fields.ohip.password.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.appKey"
        label="resources.integrations.fields.ohip.appKey.label"
        helperText="resources.integrations.fields.ohip.appKey.helperText"
        validate={required(
          'resources.integrations.fields.ohip.appKey.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.chainCode"
        label="resources.integrations.fields.ohip.chainCode.label"
        helperText="resources.integrations.fields.ohip.chainCode.helperText"
        validate={required(
          'resources.integrations.fields.ohip.chainCode.helperText'
        )}
        variant="outlined"
        fullWidth
      />
    </Box>
  </WrapperField>
);

export default OhipInputs;
